import { KrCard } from '@/common/card/KrCard';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { UsAmpTable } from './UsAmpTable';

const US_AMP_DIM_OPTIONS = [
  { value: 'INV_PERIOD', label: 'Invoice Period' },
  { value: 'PROD', label: 'Product' },
  { value: 'CUST', label: 'Customer' },
  { value: 'DIST_CHANNEL', label: 'Distributor Channel' },
  { value: 'CTRT_TYPE', label: 'Contract Type' },
];

export const UsAmpTableCard = ({
  formValues,
  brandIdToBrandName,
  custIdToCustName,
  distChannelIdToDistChannel,
  ctrtTypeIdToCtrtType,
}) => {
  const [selectedDims, setSelectedDims] = useNavStateSync(
    'usAmpSelectedDims',
    US_AMP_DIM_OPTIONS.map((option) => option.value),
  );

  const trendButtons = (
    <ToggleButtonGroup
      size="small"
      value={selectedDims}
      onChange={(event, values) => {
        setSelectedDims(values);
      }}
      sx={{ width: 'fit-content', flexWrap: 'wrap' }}
    >
      {US_AMP_DIM_OPTIONS.map((option) => (
        <ToggleButton key={option.value} value={option.value} aria-label={option.label}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );

  return (
    <KrCard title="US AMP Details" buttons={trendButtons} sx={{ flex: 1 }}>
      <UsAmpTable formValues={formValues} selectedDims={selectedDims} />
    </KrCard>
  );
};
